import { createReducer } from 'redux-act';

import * as actions from '../actions/error';

const DEFAULT_STATE = {
  info: null
};

export default createReducer(
  {
    [actions.setError]: (state, info) => ({ ...state, info }),
    [actions.errorReset]: state => ({ ...DEFAULT_STATE })
  },
  DEFAULT_STATE
);
